<template>
  <div>
    <Top></Top>
    <div class="main">
      <h2>よくある質問</h2>
      <div class="content">
        <h3>弊社のサービス関係</h3>
        <p @click="index =1">1.仕入れ代行依頼可能なルートについて</p>
        <transition name="fade">
          <div class="da" v-show="index == 1">
            <strong>A:</strong>
            <span>
              基本は当社サイトの出展店舗とアリババ、タオバオ、Ｔｍａｌｌよりの仕入れ代行が対応可能です。
              <br />そのほかご希望の工場などがある場合担当スタッフまでお問合せください。
            </span>
          </div>
        </transition>
        <p @click="index = 2">2.国際発送運送会社の選定について</p>
        <transition name="fade">
          <div class="da" v-show="index == 2">
            <strong>A:</strong>
            <span>
              弊社では、安く、確実に早く届ける運送方法を常に模索しています。日本行きの国際発送を手掛ける運送会社は多数存在し
              <br />ますが、荷物の破損や紛失事故の多い運送会社もあります、通関資格を持たず外注している業者もありますので、そういった業
              <br />者は通関手数料が高く設定し、トータルではあまりメリットがありません。安さだけでは無く、品質とコスト共に弊社基準を満
              <br />たした業者のみ、
              <router-link to="/freight" target="_blank">提携運送会社</router-link>として皆様にご案内しています。
              <br />今後も、より良い運送会社があれば、運用テストを繰り返し、お客様にご案内が出来るようであれば新たな発送ルートととし
              <br />て、ご案内させて頂きます。
            </span>
          </div>
        </transition>
        <p @click="index = 3">3.弊社のミスによる損害賠償について</p>
        <transition name="fade">
          <div class="da" v-show="index == 3">
            <strong>A:</strong>
            <span>
              弊社でご注文頂いた場合、弊社の注文ミスや検品ミス、発送ミス等、明らかに弊社のミスによる損害が生じた場合は、全額
              <br />保障させて頂いておりますので、どうか、ご安心して弊社にお任せ下さい。
              <br />弊社はお客様の買い物の代行をさせて頂く立場にありますので、注文したショップのミスに於いても返品・返金の交渉も代行さ
              <br />せて頂きます。
            </span>
          </div>
        </transition>
        <p @click="index = 4">4.荷物の発送だけやってもらえますか？</p>
        <transition name="fade">
          <div class="da" v-show="index == 4">
            <strong>A:</strong>
            <span>大変申し訳ございませんが、弊社経由以外の商品の輸出はリスクや実態把握できないため、控えさせて頂いております。</span>
          </div>
        </transition>
        <p @click="index =5">5.クレジットカードの利用は出来ますか？</p>
        <transition name="fade">
          <div class="da" v-show="index == 5">
            <strong>A:</strong>
            <span>
              直接のご利用はできないです。弊社はクレジットカード会社との提携はなく、ペイパルのご利用は可能です、そちらでクレ
              <br />ジットカードを使用できますので、決済して頂ければかと思います。
              <br />なお、ペイパル支払いによる手数料はお客様負担となりますので、予めご了承くださいませ。
            </span>
          </div>
        </transition>
        <p @click="index = 6">6.決済方法と領収書について</p>
        <transition name="fade">
          <div class="da" v-show="index == 6">
            <strong>A:</strong>
            <span>
              決済方法は銀行振り込み、ペイパル入金を受け付けております。
              <br />領収書の発行は弊社で行っておりません。
              <br />
              <em>■銀行振込でのお支払いの場合</em> 銀行振り込み明細書をもって領収書の発行に代えさせて頂きます。
              <br />
              <em>■クレジットカードでのお支払いの場合</em> クレジットカード会社発行の利用明細書が領収書となります。
            </span>
          </div>
        </transition>
        <h3>仕入れ店舗や商品関係（商習慣）</h3>
        <p @click="index = 7">1.タオバオ·アリババ店舗の価格について</p>
        <transition name="fade">
          <div class="da" v-show="index == 7">
            <strong>A:</strong>
            <span>
              いざ、発注してみると金額が上がる場合が稀にあります。殆どの場合、表示価格で商品を購入出来るのですが、ごく稀に上位
              <br />表示を狙って、極端に安い金額表示を出す事があります。
              <br />実際には高い金額を提示してくる場合があります。また、左右対称の２個セットの商品、例えば手袋のような商品、左右セット
              <br />でしか成立しない商品でも片側のみの金額表示のショップがあります。 恐らく上位表示を狙ったものですが、弊社を通じてショ
              <br />ップに問合せをすることをお勧めします。
              <br />それ以外にタオバオでの格安商品でよく見かける商法手口として、商品代金を国内送料に上乗せし、販売する店舗もございま
              <br />す。
            </span>
          </div>
        </transition>
        <p @click="index = 8">2.突然材質、色や品質が変わるケース</p>
        <transition name="fade">
          <div class="da" v-show="index == 8">
            <strong>A:</strong>
            <span>
              これまで安定的に仕入れが出来ていても、突然品質が変わる（商品が変わる）事があります。
              <br />ショップの在庫が切れた場合に、他店（同業者）から仕入れる場合があります。
              <br />同じ工場で製造されたものなら良いですが、ノーブランドであっても他の工場が類似品（委託又は無断複製）を製造する場合も
              <br />あります。
              <br />その場合、商品ページにはオリジナルの写真が使われます。また、工場が再生産や、材料が無くなった時に、価格競争やコスト
              <br />ダウンの為に安い材料に変えてしまう等、複雑に絡み合うことによって、このような事象が発生します。
              <br />安定的に品質を保つには、材料からのOEMという手法もあります。
            </span>
          </div>
        </transition>
        <p @click="index = 9">3.パッケージが潰れている</p>
        <transition name="fade">
          <div class="da" v-show="index == 9">
            <strong>A:</strong>
            <span>
              日本では、パッケージも商品の一部として価値がある事は理解しております。
              <br />中国の商習慣に於いては、外箱に価値は無く、商品そのものに問題が無ければ、不良品と認められません。
              <br />箱はおまけという考え方です。その為、購入ショップでは、返金・返品に応じてもらえません。
              <br />箱だけを追加販売して貰う方法もありますが、殆どのショップがセットだからという理由で販売してもらえません。
              <br />場合によっては、パッケージをOEM製作をして、弊社で入れ替える事も可能ですので、ご相談下さい。
            </span>
          </div>
        </transition>
        <p @click="index = 10">4.セール商品·相場よりも安い商品について</p>
        <transition name="fade">
          <div class="da" v-show="index == 10">
            <strong>A:</strong>
            <span>
              アリババやタオバオでセール品や、相場よりも安い商品の多くが返品不可の場合があります。
              <br />購入前は、返品可でも、実際返品出来ない場合があります、予めご了承下さい。
              <br />特に、相場より安い商品は、B品だったり、返品商品のセールの可能性がありますので、商品選定には充分お気をつけ下さい。
              <br />当社サイトの商品であればセール品に訳アリ品がある場合は明記させて頂きますので、ご安心ください。
            </span>
          </div>
        </transition>
        <p @click="index = 11">5.購入商品の返品や交換</p>
        <transition name="fade">
          <div class="da" v-show="index == 11">
            <strong>A:</strong>
            <span>
              日本では商品の返品・交換時の送料はショップ負担ですが、中国ではお客様負担となります。
              <br />特に単価の安い商品ですと、往復送料の方が高くつく事もあります。
              <br />商品単価や、返品点数によっては、返品することで損害が拡大する場合が御座います。
              <br />店舗によっては、不良品を不良品と認めない店舗もありますので、ショップ選びは重要です。
              <br />特にOEM商品はほぼ１００％返品出来ません。オーダーメイドですので、日本でも返品出来ないはずです。
            </span>
          </div>
        </transition>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
export default {
  data() {
    return {
      index: 0
    };
  },
  components: {
    Top,
    Foot
  },
  methods: {}
};
</script>
<style lang='scss' scoped>
.main {
  width: 1200px;
  margin: 0 auto 150px;
  h2 {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    margin: 120px 0 80px;
  }
  .content {
    padding-left: 200px;
    h3 {
      margin-top: 100px;
      font-size: 24px;
      height: 26px;
      line-height: 26px;
      padding-left: 10px;
      border-left: 10px solid #F3C622;
      margin-bottom: 50px;
    }
    p {
      font-size: 18px;
      line-height: 80px;
      cursor: pointer;
    }
    .da {
      strong {
        font-weight: 700;
        font-size: 16px;
      }
      span {
        font-size: 12px;
      }
      a {
        font-size: 18px;
        color: #F3C622;
      }
      em {
        display: inline-block;
        width: 250px;
      }
    }
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
  }
}
</style>